module.exports = __webpack_public_path__ + "static/media/nav-chevron.e5032b77.svg";